import React from 'react';
import LogInPage from './containers/LogInPage';
import OrderPage from './containers/OrderPage';
import TradePage from './containers/TradePage';
import SummaryPage from './containers/SummaryPage';
import SummaryChartPage from './containers/SummaryChartPage';
import DashboardPage from './containers/DashboardPage';
import OvernightDashboardPage from './containers/OvernightDashboardPage';
import AtsTddsDashboardPage from './containers/AtsTddsDashboardPage';
import IdqsTradePage from './containers/IdqsTradePage';
import IdqsOrderPage from './containers/IdqsOrderPage';
import IdqsOpenOrderPage from './containers/IdqsOpenOrderPage';
import EcnOpenOrderPage from './containers/EcnOpenOrderPage';
import NmsOpenOrderPage from './containers/NmsOpenOrderPage';
import NmsOrderPage from './containers/NmsOrderPage';
import NmsTradePage from './containers/NmsTradePage';
import EcnHelpPage from './containers/EcnHelpPage';
import HistoricalDashboardPage from './containers/HistoricalDashboardPage';
import HistoricAtsTddsDashboardPage from './containers/HistoricAtsTddsDashboardPage';
import HistoricalOvernightDashboardPage from './containers/HistoricalOvernightDashboardPage';
import MobileDashboardPage from './containers/MobileDashboardPage';
import RiskDashboardPage from './containers/RiskDashboardPage';
import HistoricalRiskDashboardPage from './containers/HistoricalRiskDashboardPage';

import * as Routes from './util/routeConstants';

const routes = [
  {
    path: Routes.ORDER.path,
    exact: true,
    component: <OrderPage />,
    public: false,
    name: Routes.ORDER.name

  }, {
    path: Routes.OPEN_ORDER.path,
    exact: true,
    component: <EcnOpenOrderPage />,
    public: false,
    name: Routes.OPEN_ORDER.name

  }, {
    path: Routes.TRADE.path,
    exact: true,
    component: <TradePage />,
    public: false,
    name: Routes.TRADE.name

  },
  {
    path: Routes.HELP.path,
    exact: true,
    component: <EcnHelpPage />,
    public: false,
    name: Routes.HELP.name

  },
  {
    path: Routes.TRADE_SUMMARY.path,
    exact: true,
    component: <SummaryPage />,
    public: false,
    name: Routes.TRADE_SUMMARY.name

  }, {
    path: Routes.TRADE_SUMMARY_CHART.path,
    exact: true,
    component: <SummaryChartPage />,
    public: false,
    name: Routes.TRADE_SUMMARY_CHART.name

  }, {
    path: Routes.DASHBOARD.path,
    exact: true,
    component: <DashboardPage />,
    public: false,
    name: Routes.DASHBOARD.name

  }, {
    path: Routes.OVERNIGHT_DASHBOARD.path,
    exact: true,
    component: <OvernightDashboardPage />,
    public: false,
    name: Routes.OVERNIGHT_DASHBOARD.name

  }, {
    path: Routes.ATS_TDDS_DASHBOARD.path,
    exact: true,
    component: <AtsTddsDashboardPage />,
    public: false,
    name: Routes.ATS_TDDS_DASHBOARD.name

  },
  {
    path: Routes.HISTORIC_DASHBOARD.path,
    exact: true,
    component: <HistoricalDashboardPage />,
    public: false,
    name: Routes.HISTORIC_DASHBOARD.name

  }, {
    path: Routes.HISTORIC_OVERNIGHT_DASHBOARD.path,
    exact: true,
    component: <HistoricalOvernightDashboardPage />,
    public: false,
    name: Routes.HISTORIC_OVERNIGHT_DASHBOARD.name

  }, {
    path: Routes.ATS_TDDS_HISTORIC_DASHBOARD.path,
    exact: true,
    component: <HistoricAtsTddsDashboardPage />,
    public: false,
    name: Routes.ATS_TDDS_HISTORIC_DASHBOARD.name

  }, {
    path: Routes.RISK_DASHBOARD.path,
    exact: true,
    component: <RiskDashboardPage />,
    public: false,
    name: Routes.RISK_DASHBOARD.name

  }, {
    path: Routes.HISTORY_RISK_DASHBOARD.path,
    exact: true,
    component: <HistoricalRiskDashboardPage />,
    public: false,
    name: Routes.HISTORY_RISK_DASHBOARD.name

  }, {
    path: Routes.LOGIN.path,
    exact: true,
    component: <LogInPage />,
    public: true,
    name: Routes.LOGIN.name
  }, {
    path: Routes.IDQS_ORDER.path,
    exact: true,
    component: <IdqsOrderPage />,
    public: false,
    name: Routes.IDQS_ORDER.name
  }, {
    path: Routes.IDQS_OPEN_ORDER.path,
    exact: true,
    component: <IdqsOpenOrderPage />,
    public: false,
    name: Routes.IDQS_OPEN_ORDER.name

  }, {
    path: Routes.IDQS_TRADE.path,
    exact: true,
    component: <IdqsTradePage />,
    public: false,
    name: Routes.IDQS_TRADE.name
  },
  {
    path: Routes.MOBILE_DASHBOARD.path,
    exact: true,
    component: <MobileDashboardPage />,
    public: false,
    name: Routes.MOBILE_DASHBOARD.name

  },
  // NMS
  {
    path: Routes.NMS_OPEN_ORDER.path,
    exact: true,
    component: <NmsOpenOrderPage />,
    public: false,
    name: Routes.NMS_OPEN_ORDER.name

  },
  {
    path: Routes.NMS_ORDER.path,
    exact: true,
    component: <NmsOrderPage />,
    public: false,
    name: Routes.NMS_ORDER.name

  },
  {
    path: Routes.NMS_TRADE.path,
    exact: true,
    component: <NmsTradePage />,
    public: false,
    name: Routes.NMS_TRADE.name

  }
];

export default routes;
